import { useState } from "react";
import CreatorLinkPreview from "./CreatorLinkPreview";
import { creatorPageThemes } from "./homeCreatorContent";
import { trackClarityEvent } from "../../utils/clarityAnalytics";
import styles from "./HomeCreatorLanding.module.scss";

// Three stacked link pages; tapping one brings its design to the front.
export default function ThemeShowcase({ presets = creatorPageThemes, decorative = false, className = "" }) {
  const [selected, setSelected] = useState(0);
  return <div className={`${styles.themeShowcase} ${className}`} role={decorative ? undefined : "group"}
    aria-label={decorative ? undefined : "Choose a page design"} aria-hidden={decorative || undefined}>
    {presets.map((preset, index) => {
      const position = index === selected ? "front" : index === (selected + 1) % 3 ? "left" : "right";
      return <div className={styles.themeCard} data-position={position} key={preset.key}>
        <div className={styles.themePage} aria-hidden="true" inert="">
          <CreatorLinkPreview preset={preset} />
        </div>
        {!decorative ? <button type="button" className={styles.themeChoice} aria-label={`Use ${preset.label} design`}
          aria-pressed={index === selected} onClick={() => {
            setSelected(index);
            trackClarityEvent(`home_theme_${preset.key.replace(/-/g, "_")}_selected`);
          }} /> : null}
      </div>;
    })}
  </div>;
}
